// extracted by mini-css-extract-plugin
module.exports = {"dialogPaper":"styles_dialogPaper__3kfPs","yayImg":"styles_yayImg__3t1mK","submittedHeader":"styles_submittedHeader__2bn2b","doneButton":"styles_doneButton__3N4nE"};